import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

export const CONSIGNMENT_STAGE_URL = 'consignment/statuses'

const errors = createHandbookResponseErrors('этап', 'этапов')

export const ConsignmentStageApi = createNewHandbookApi(CONSIGNMENT_STAGE_URL, errors)
